import { postCoreSonarObjectsSalesforceUpdateableAsyncSlice } from './post';

export const { requestPostCoreSonarObjectsSalesforceUpdateable, resetPostCoreSonarObjectsSalesforceUpdateable } =
	postCoreSonarObjectsSalesforceUpdateableAsyncSlice.asyncActionCreators;
